{ "//": "THIS FILE IS AUTOGENERATED. DO NOT EDIT MANUALLY. To update: pnpm run schema:build", "RetentionQuery": 2 }
